import React, { useMemo, ReactElement, useState, useEffect } from 'react';
import { getCurrentGiftApi, getLogEntriesApi } from '../../api';
import WealthieBreadCrumb from '../../components/BreadCrumb';
import WealthieTable from '../../components/WelthieTable';
import moment from 'moment';
import { useParams, Link } from 'react-router-dom';
import { Descriptions } from 'antd';
import { GiftCardType } from '../../types';
import { get } from 'lodash';
import showNotification from '../../components/Notification';

const defaultStartDate = moment().subtract(1, 'months').format('DD/MM/YYYY');
const defaultEndDate = moment().format('DD/MM/YYYY');

type GiftDetailParams = {
  giftId: string;
};

const GiftDetail = (): ReactElement => {
  const { giftId } = useParams<GiftDetailParams>();
  const [currentGift, setCurrentGift] = useState<GiftCardType>();

  const breadcrumbConfig = useMemo(
    () => [
      {
        name: 'Wealthie',
      },
      {
        name: 'Giftcards',
        link: '/gift-card',
      },
      {
        name: 'Giftcard Detail',
      },
    ],
    [],
  );

  const logCollumns = useMemo(
    () => [
      {
        title: 'Action Timestamp',
        dataIndex: 'action_timestamp',
        key: 'action_timestamp',
      },
      {
        title: 'Action Description',
        dataIndex: 'action_description',
        key: 'action_description',
      },
      {
        title: 'Action Notes',
        dataIndex: ' action_notes',
        key: 'action_notes',
      },
    ],
    [],
  );

  useEffect(() => {
    async function fetchCurrentGift() {
      try {
        const giftRes = await getCurrentGiftApi(giftId);
        setCurrentGift(get(giftRes, 'data[0]', {}));
      } catch (error) {
        showNotification({
          type: 'error',
          message: 'Somethings went wrong, please try again',
        });
      }
    }
    fetchCurrentGift();
  }, [giftId]);

  return (
    <>
      <WealthieBreadCrumb breadcrumbConfig={breadcrumbConfig} />
      <Descriptions title="Giftcard info">
        <Descriptions.Item label="ID">
          {currentGift && currentGift.id}
        </Descriptions.Item>
        <Descriptions.Item label="Child Id">
          <Link
            to={`/child/${currentGift?.parent_id}/${currentGift?.child_id}`}
          >
            {currentGift && currentGift.child_id}
          </Link>
        </Descriptions.Item>
        <Descriptions.Item label="Created At">
          {currentGift && currentGift.created_at}
        </Descriptions.Item>
        <Descriptions.Item label="Amount">
          {currentGift && currentGift.giftcard_amt}
        </Descriptions.Item>
        <Descriptions.Item label="Giftcard Currency">
          {currentGift && currentGift.giftcard_currency}
        </Descriptions.Item>
        <Descriptions.Item label="giftcard experience link">
          {currentGift && currentGift.giftcard_experience_link}
        </Descriptions.Item>
        <Descriptions.Item label="giftcard type id">
          {currentGift && currentGift.giftcard_type_id}
        </Descriptions.Item>
        <Descriptions.Item label="last email sent">
          {currentGift && currentGift.last_email_sent}
        </Descriptions.Item>
        <Descriptions.Item label="last email status">
          {currentGift && currentGift.last_email_status}
        </Descriptions.Item>
        <Descriptions.Item label="message">
          {currentGift && currentGift.message}
        </Descriptions.Item>
        <Descriptions.Item label="parent id">
          <Link to={`/users/${currentGift?.parent_id}`}>
            {currentGift && currentGift.parent_id}
          </Link>
        </Descriptions.Item>
        <Descriptions.Item label="parent phone number">
          {currentGift && currentGift.parent_phone_number}
        </Descriptions.Item>
        <Descriptions.Item label="recipient email">
          {currentGift && currentGift.recipient_email}
        </Descriptions.Item>
        <Descriptions.Item label="recipient name">
          {currentGift && currentGift.recipient_name}
        </Descriptions.Item>
        <Descriptions.Item label="record id">
          {currentGift && currentGift.record_id}
        </Descriptions.Item>
        <Descriptions.Item label="sender email">
          {currentGift && currentGift.sender_email}
        </Descriptions.Item>
        <Descriptions.Item label="sender name">
          {currentGift && currentGift.sender_name}
        </Descriptions.Item>
        <Descriptions.Item label="status">
          {currentGift && currentGift.status}
        </Descriptions.Item>
        <Descriptions.Item label="stripe transaction id">
          {currentGift && currentGift.stripe_transaction_id}
        </Descriptions.Item>
        <Descriptions.Item label="transaction timestamp">
          {currentGift && currentGift.transaction_timestamp}
        </Descriptions.Item>
        <Descriptions.Item label="updated at">
          {currentGift && currentGift.updated_at}
        </Descriptions.Item>
        <Descriptions.Item label="woocommerce id">
          {currentGift && currentGift.woo_commerce_id}
        </Descriptions.Item>
      </Descriptions>
      <div>Log Entries</div>
      <WealthieTable
        isShowLoadingOnStart
        rowKey="id"
        api={getLogEntriesApi}
        columns={logCollumns}
        extraApiParams={[
          defaultStartDate,
          defaultEndDate,
          undefined,
          undefined,
          giftId,
        ]}
        onChangeCallBack={undefined}
      />
    </>
  );
};

export default GiftDetail;
